module.exports = __webpack_public_path__ + "img/qr.82754cc2.png";